// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../../../../types";

import gql from "graphql-tag";
import {
  ProposalCardEventFragmentDoc,
  ProposalCardProposalFragmentDoc,
} from "../ProposalCard/ProposalCard.generated-types";
export type RequestedProposalEventFragment = {
  __typename?: "Event";
  currency: string;
  layoutID: string;
  fromDateTime: string;
  toDateTime: string;
  proposalCount: number;
  status: Types.EventStatus;
};

export type RequestedProposalProposalFragment = {
  __typename?: "Proposal";
  status: Types.ProposalStatus;
  hasPreferredVenue: boolean;
  ID: number;
  currency: string;
  baseCostTotal: number;
  baseCostDescription: string;
  message?: string | null;
  space: {
    __typename?: "SelfServeSpace";
    spaceName?: string | null;
    description?: string | null;
    hostContact: {
      __typename?: "HostContact";
      email?: string | null;
      phoneNumber?: string | null;
    };
    spacePhotos?: Array<{
      __typename?: "SelfServeSpacePhoto";
      url?: string | null;
    }> | null;
    venue?: {
      __typename?: "SelfServeVenue";
      name?: string | null;
      addressLine1?: string | null;
      city?: string | null;
      postalCode?: string | null;
      nearestTransit?: {
        __typename?: "NearestTransit";
        station?: string | null;
      } | null;
    } | null;
    spatialConfigurations?: Array<{
      __typename?: "SelfServeSpatialConfiguration";
      name?: string | null;
      capacity?: number | null;
    }> | null;
    spaceFeatures?: Array<{
      __typename?: "SelfServeSpaceFeature";
      ID?: number | null;
      name?: string | null;
    }> | null;
  };
  extraCostItems?: Array<{
    __typename?: "ExtraCostItem";
    ID: number;
    description: string;
    quantity?: number | null;
    costPerUnit: number;
  }> | null;
  documents?: Array<{
    __typename?: "ProposalDocument";
    ID: number;
    URL: string;
    filename: string;
  }> | null;
};

export const RequestedProposalEventFragmentDoc = gql`
  fragment RequestedProposalEvent on Event {
    ...ProposalCardEvent
  }
  ${ProposalCardEventFragmentDoc}
`;
export const RequestedProposalProposalFragmentDoc = gql`
  fragment RequestedProposalProposal on Proposal {
    space {
      hostContact {
        email
        phoneNumber
      }
    }
    ...ProposalCardProposal
  }
  ${ProposalCardProposalFragmentDoc}
`;
